import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.FDG_FLIGHTS,
    name: "fdgList",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FDG_FLIGHTS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.FDG_FLIGHTS.PERMISSIONS,
    },
    component: () => import("@/modules/FDG/views/GroupFlightsList.vue"),
  },
  {
    path: PATH.FDG_FLIGHT_DETAIL,
    name: "fdgDetail",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FDG_FLIGHTS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.FDG_FLIGHTS.PERMISSIONS,
    },
    component: () => import("@/modules/FDG/views/GroupFlightDetail.vue"),
  },
  {
    path: PATH.FDG_UMRAH,
    name: "umrah",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FDG_FLIGHTS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.FDG_FLIGHTS.PERMISSIONS,
    },
    component: () => import("@/modules/FDG/views/UmrahList.vue"),
  },
  {
    path: PATH.FDG_UMRAH_DETAIL,
    name: "umrahDetail",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FDG_UMRAH.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.FDG_UMRAH.PERMISSIONS,
    },
    component: () => import("@/modules/FDG/views/UmrahDetail.vue"),
  },
  {
    path: PATH.FDG_BOOKING_DETAILS,
    name: "groupFlightDetails",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FDG_FLIGHTS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.FDG_FLIGHTS.PERMISSIONS,
    },
    component: () =>
      import("@/modules/FDG/views/GroupFlightBookingDetails.vue"),
  },
  {
    path: PATH.FDG_FLIGHT_BOOKING_CONFIRMATION,
    name: "groupFlightDetailsForm",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FDG_FLIGHTS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.FDG_FLIGHTS.PERMISSIONS,
    },
    component: () => import("@/modules/FDG/views/GroupBookingForm.vue"),
  },
];

export default routes;
